import React from 'react';

export default function I18nParagraph(chunks: React.ReactNode) {
  return <p className="mb-3 type-body1">{chunks}</p>;
}
